if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('.product-form__submit') || this.querySelector('[type="submit"]');

        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt, retries = 0) {
        evt.preventDefault();
        window.cartRequestInProgress = true;
        if (this.submitButton.getAttribute('aria-disabled') === 'true' && retries === 0) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const handleFinally = () => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        };

        const isGift = this.dataset.isGift === 'true';

        if (isGift) {
          const recipientName = this.querySelector('[name="properties[Recipient name]"][required]');

          if (recipientName?.value === '') {
            const response = {
              status: 422,
              description: { name: ["Name can't be blank"] },
              errors: { name: ["Name can't be blank"] },
              message: "Validation failed: Name can't be blank",
            };
            response.message = "Validation failed: Name can't be blank";

            if (this.querySelector('[name="properties[Recipient email]"]')?.value === '') {
              response.description.email = ["Email can't be blank"];
              response.errors.email = ["Email can't be blank"];
              response.message = "Validation failed: Name can't be blank and Email can't be blank";
            }

            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            handleFinally();
            return;
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
                originalEvent: evt,
                retries: retries,
                originator: this,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(handleFinally);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (text) {
            this.submitButtonText.textContent = text;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      handleNotificationButton(newButton) {
        if (!newButton) return;

        const hasKlaviyoFormId =
          newButton.hasAttribute('data-klaviyo-form-id') && newButton.getAttribute('data-klaviyo-form-id') !== '';
        const isKlaviyoFormTrigger = newButton.getAttribute('is') === 'klaviyo-form-trigger';

        const hasKlaviyoFormTrigger = this.submitButton.dataset.hasKlaviyoFormTrigger === 'true';

        if (hasKlaviyoFormId && isKlaviyoFormTrigger) {
          this.submitButton.setAttribute('type', 'button');
          this.submitButton.setAttribute('data-klaviyo-form-id', newButton.getAttribute('data-klaviyo-form-id'));
          this.submitButton.setAttribute('is', 'klaviyo-form-trigger');

          if (!hasKlaviyoFormTrigger) {
            this.submitButton.onClick = window.KlaviyoFormTrigger.prototype.onClick;
            this.submitButton.boundOnClick = this.submitButton.onClick.bind(this.submitButton);
            this.submitButton.addEventListener('click', this.submitButton.boundOnClick);
          }
        } else {
          if (this.submitButton?.disconnectedCallback) {
            this.submitButton.disconnectedCallback();
          }
          this.submitButton.removeAttribute('data-klaviyo-form-id');
          this.submitButton.removeAttribute('is');
          if (this.submitButton.getAttribute('type') === 'button') {
            this.submitButton.setAttribute('type', 'submit');
          }

          this.submitButton.removeEventListener('click', this.submitButton.boundOnClick);
          this.submitButton.onClick = null;
          this.submitButton.boundOnClick = null;
        }

        this.submitButton.innerHTML = newButton.innerHTML;
      }
    }
  );
}
